import { Box } from "@mui/material";
import { useEffect } from "react";
import { useAuth } from "../hooks/useAuth";

const Logout = () => {
  const { storageDelete } = useAuth();

  useEffect(() => {
    storageDelete();
    window.location.assign("/");
  }, [storageDelete]);

  return <Box>Deslogando...</Box>;
};

export default Logout;
